/*
 * Copyright (c) 2020, WSO2 Inc. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 Inc. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { ApplicationList, Application } from "../../data/interfaces";

export const FETCH_APPLICATION_REQUEST = 'FETCH_APPLICATION_REQUEST';
export const FETCH_APPLICATION_SUCCESS = 'FETCH_APPLICATION_SUCCESS';
export const FETCH_APPLICATION_FAILURE = 'FETCH_APPLICATION_FAILURE';

export const FETCH_APPLICATION_DETAILS_REQUEST = 'FETCH_APPLICATION_DETAILS_REQUEST';
export const FETCH_APPLICATION_DETAILS_SUCCESS = 'FETCH_APPLICATION_DETAILS_SUCCESS';
export const FETCH_APPLICATION_DETAILS_FAILURE = 'FETCH_APPLICATION_DETAILS_FAILURE';

export const UPDATE_APPLICATION_REQUEST = 'UPDATE_APPLICATION_REQUEST';
export const UPDATE_APPLICATION_SUCCESS = 'UPDATE_APPLICATION_SUCCESS';
export const UPDATE_APPLICATION_FAILURE = 'UPDATE_APPLICATION_FAILURE';

export const CREATE_APPLICATION_REQUEST = 'CREATE_APPLICATION_REQUEST';
export const CREATE_APPLICATION_SUCCESS = 'CREATE_APPLICATION_SUCCESS';
export const CREATE_APPLICATION_FAILURE = 'CREATE_APPLICATION_FAILURE';

export const DELETE_APPLICATION_REQUEST = 'DELETE_APPLICATION_REQUEST';
export const DELETE_APPLICATION_SUCCESS = 'DELETE_APPLICATION_SUCCESS';
export const DELETE_APPLICATION_FAILURE = 'DELETE_APPLICATION_FAILURE';

export const SHARE_APPLICATION_REQUEST = 'SHARE_APPLICATION_REQUEST';
export const SHARE_APPLICATION_SUCCESS = 'SHARE_APPLICATION_SUCCESS';
export const SHARE_APPLICATION_FAILURE = 'SHARE_APPLICATION_FAILURE';

export const DELETE_SHARE_APPLICATION_REQUEST = 'DELETE_SHARE_APPLICATION_REQUEST';
export const DELETE_SHARE_APPLICATION_SUCCESS = 'DELETE_SHARE_APPLICATION_SUCCESS';
export const DELETE_SHARE_APPLICATION_FAILURE = 'DELETE_SHARE_APPLICATION_FAILURE';

export interface ApplicationsAction {
    type: typeof FETCH_APPLICATION_REQUEST | typeof FETCH_APPLICATION_SUCCESS | typeof FETCH_APPLICATION_FAILURE
        | typeof FETCH_APPLICATION_DETAILS_REQUEST | typeof FETCH_APPLICATION_DETAILS_SUCCESS
        | typeof FETCH_APPLICATION_DETAILS_FAILURE | typeof UPDATE_APPLICATION_REQUEST
        | typeof UPDATE_APPLICATION_SUCCESS | typeof UPDATE_APPLICATION_FAILURE | typeof DELETE_APPLICATION_REQUEST
        | typeof DELETE_APPLICATION_SUCCESS | typeof DELETE_APPLICATION_FAILURE 
        | typeof SHARE_APPLICATION_REQUEST | typeof SHARE_APPLICATION_SUCCESS | typeof SHARE_APPLICATION_FAILURE 
        | typeof DELETE_SHARE_APPLICATION_REQUEST | typeof DELETE_SHARE_APPLICATION_SUCCESS | typeof DELETE_SHARE_APPLICATION_FAILURE,
    payload?: ApplicationList | Application | string
}

export interface CreateApplicationsAction {
    type: typeof CREATE_APPLICATION_REQUEST | typeof CREATE_APPLICATION_SUCCESS | typeof CREATE_APPLICATION_FAILURE,

    payload?: Application | string
}
